import { useI18n } from "../i18n/i18n";
import { usePageMeta } from "../lib/meta";

export function NotFound() {
  const { language } = useI18n();
  const it = language === "it";
  usePageMeta(it ? "Pagina non trovata — Mattia D’Elia" : "Page not found — Mattia D’Elia", it ? "Questa pagina non è stata trovata." : "This page could not be found.", location.pathname);
  return <main className="not-found"><span>404</span><h1>{it ? "Questa pagina ha preso un’altra strada." : "This route wandered off."}</h1><p>{it ? "Il resto del sito è esattamente dove dovrebbe essere." : "The rest of the site is exactly where it should be."}</p><div><a href="/">{it ? "Torna alla home" : "Return home"}</a><a href="/websites">{it ? "Esplora i siti" : "Explore websites"}</a></div></main>;
}
